export const seoData = {
  // 1) Pəncərə sistemləri
  "veka-pencereleri": {
    path: "/details/veka-pencereleri",
    title: "Veka pəncərələri – Alman keyfiyyəti ilə pəncərə sistemləri | AzGlass",
    description:
      "Veka pəncərələrinin hazırlanması və quraşdırılması. Yüksək istilik və səs izolyasiyası, uzunömürlü və estetik həllər.",
    keywords:
      "veka pəncərələri, plastik pəncərə, pəncərə sistemləri, istilik izolyasiyası, səs izolyasiyası",
    schemaType: "Service",
  },
  "aluminium-izosistem": {
    path: "/details/aluminium-izosistem",
    title: "Alüminium izosistem – Enerji qənaətli qapı və pəncərə sistemləri | AzGlass",
    description:
      "Alüminium izosistem qapı və pəncərələrin istehsalı və quraşdırılması. Müasir dizayn, yüksək izolyasiya və dayanıqlılıq.",
    keywords:
      "alüminium izosistem, alüminium pəncərə, alüminium qapı, izolyasiya, enerji qənaəti",
    schemaType: "Service",
  },
  "hebe-schiebe": {
    path: "/details/hebe-schiebe",
    title: "Hebe Schiebe – Sürüşən qapı sistemləri və panoramik həllər | AzGlass",
    description:
      "Hebe Schiebe sürüşən qapı sistemləri. Panoramik görünüş, rahat istifadə və premium keyfiyyət ilə müasir həll.",
    keywords:
      "hebe schiebe, sürüşən qapı, panoramik qapı, alüminium sistem, premium qapı",
    schemaType: "Service",
  },
  "taxta-pencereler": {
    path: "/details/taxta-pencereler",
    title: "Taxta pəncərələr – Təbii material, estetik görünüş və izolyasiya | AzGlass",
    description:
      "Taxta pəncərə sistemlərinin hazırlanması və montajı. Ekoloji təmiz, istilik/səs izolyasiyası güclü, estetik dizayn.",
    keywords:
      "taxta pəncərə, taxta pəncərə sistemləri, ekoloji pəncərə, izolyasiya, pəncərə montajı",
    schemaType: "Service",
  },
  "sebeke-karolaj": {
    path: "/details/sebeke-karolaj",
    title: "Şəbəkə (Karolaj) – Pəncərələr üçün dekorativ dizayn həlləri | AzGlass",
    description:
      "Karolaj şəbəkə sistemləri ilə pəncərələrinizə klassik və estetik görünüş verin. Dəqiq ölçü, səliqəli montaj və keyfiyyət.",
    keywords:
      "karolaj, şəbəkə pəncərə, dekorativ pəncərə, pəncərə dizaynı, klassik üslub",
    schemaType: "Service",
  },
  "giyotin-pencereler": {
    path: "/details/giyotin-pencereler",
    title: "Giyotin pəncərələr – Avtomatik şaquli açılan pəncərə sistemləri | AzGlass",
    description:
      "Avtomatik giyotin pəncərə sistemləri. Kafe, restoran və yaşayış binaları üçün təhlükəsiz və komfortlu həll.",
    keywords:
      "giyotin pəncərə, avtomatik pəncərə, şaquli pəncərə, restoran pəncərə, kafe sistemi",
    schemaType: "Service",
  },

  // 2) Metal Konstruksiya
  anbarlar: {
    path: "/details/anbarlar",
    title: "Anbarlar – Metal konstruksiya anbarların hazırlanması və quraşdırılması | AzGlass",
    description:
      "Metal konstruksiya anbarların layihələndirilməsi, istehsalı və quraşdırılması. Dayanıqlı karkas, etibarlı montaj və uzunömürlülük.",
    keywords:
      "metal anbar, metal konstruksiya anbar, anbar tikintisi, karkas sistem, sənaye anbarı",
    schemaType: "Service",
  },
  "metal-sohbetgah": {
    path: "/details/metal-sohbetgah",
    title: "Metal söhbətgah – Bağ və həyət üçün metal söhbətgah modelləri | AzGlass",
    description:
      "Metal söhbətgahların hazırlanması və quraşdırılması. Estetik dizayn, möhkəm konstruksiya və fərdi ölçülərdə istehsal.",
    keywords:
      "metal söhbətgah, metal sohbetgah, bağ üçün söhbətgah, metal gazebo, həyət söhbətgahı",
    schemaType: "Service",
  },
  pilleken: {
    path: "/details/pilleken",
    title: "Pilləkən – Metal pilləkənlərin hazırlanması və montajı | AzGlass",
    description:
      "Daxili və xarici metal pilləkənlərin layihələndirilməsi və quraşdırılması. Təhlükəsiz, dayanıqlı və modern dizayn.",
    keywords:
      "metal pilləkən, pilləkən montajı, pilləkən dizaynı, daxili pilləkən, xarici pilləkən",
    schemaType: "Service",
  },
  meheccer: {
    path: "/details/meheccer",
    title: "Məhəccər – Balkon və pilləkən üçün məhəccər sistemləri | AzGlass",
    description:
      "Balkon, pilləkən və terras üçün məhəccər sistemlərinin hazırlanması və quraşdırılması. Təhlükəsizlik və estetik görünüş bir arada.",
    keywords:
      "məhəccər, balkon məhəccər, pilləkən məhəccər, məhəccər montajı, təhlükəsizlik",
    schemaType: "Service",
  },
  "loft-soft": {
    path: "/details/loft-soft",
    title: "Loft Soft – Industrial üslubda metal konstruksiya həlləri | AzGlass",
    description:
      "Loft Soft üslubunda metal konstruksiya və dizayn həlləri. Modern interyer/eksteryer üçün funksional və estetik seçim.",
    keywords:
      "loft soft, industrial dizayn, metal konstruksiya, loft üslub, modern interyer",
    schemaType: "Service",
  },
  "avtomatik-qapilar": {
    path: "/details/avtomatik-qapilar",
    title: "Avtomatik qapılar – Sensorlu və motorlu giriş sistemləri | AzGlass",
    description:
      "Avtomatik qapı sistemlərinin satışı və montajı. Sensorlu giriş, rahat idarəetmə və təhlükəsizlik üçün müasir həll.",
    keywords:
      "avtomatik qapı, sensorlu qapı, motorlu qapı, giriş sistemi, avtomatik şüşə qapı",
    schemaType: "Service",
  },

  // 3) Fasad sistemləri
  "suse-fasad-cebhe": {
    path: "/details/suse-fasad-cebhe",
    title: "Şüşə fasad – Müasir bina cəbhələri üçün fasad sistemləri | AzGlass",
    description:
      "Şüşə fasad (cəbhə) sistemlərinin hazırlanması və quraşdırılması. Ticarət və yaşayış binaları üçün modern memarlıq həlli.",
    keywords:
      "şüşə fasad, bina cəbhəsi, fasad sistemi, vitrin fasad, modern fasad",
    schemaType: "Service",
  },
  "aluminium-kompozit-panel-alkopon": {
    path: "/details/aluminium-kompozit-panel-alkopon",
    title: "Alüminium kompozit panel (Alkopon) – Fasad üzlükləri | AzGlass",
    description:
      "Alkopon alüminium kompozit panel fasad üzlükləri. Dayanıqlı, yüngül və estetik görünüşlü fasad həlləri.",
    keywords:
      "alkopon, alüminium kompozit panel, fasad üzlük, kompozit fasad, panel montajı",
    schemaType: "Service",
  },

  // 4) Məhəccər (kateqoriya)
  "tokme-aluminium": {
    path: "/details/tokme-aluminium",
    title: "Tökmə alüminium – Premium tökmə məhəccər və dekorativ elementlər | AzGlass",
    description:
      "Tökmə alüminium məhəccər və dekorativ elementlərin hazırlanması. Klassik görünüş, yüksək davamlılıq və keyfiyyətli işləmə.",
    keywords:
      "tökmə alüminium, tökmə məhəccər, dekorativ məhəccər, klassik dizayn, premium məhəccər",
    schemaType: "Service",
  },
  "suse-meheccer": {
    path: "/details/suse-meheccer",
    title: "Şüşə məhəccər – Minimalist və modern şüşə məhəccər sistemləri | AzGlass",
    description:
      "Şüşə məhəccər sistemlərinin quraşdırılması. Modern görünüş, təhlükəsizlik və məkanınıza genişlik effekti verən həll.",
    keywords:
      "şüşə məhəccər, glass railing, balkon şüşə məhəccər, modern məhəccər, təhlükəsizlik şüşəsi",
    schemaType: "Service",
  },
  "metal-meheccer": {
    path: "/details/metal-meheccer",
    title: "Metal məhəccər – Balkon və pilləkən üçün metal məhəccərlər | AzGlass",
    description:
      "Metal məhəccərlərin hazırlanması və montajı. Dayanıqlı material, səliqəli dizayn və təhlükəsizlik standartları ilə uyğun həll.",
    keywords:
      "metal məhəccər, balkon məhəccər, pilləkən məhəccər, metal railing, məhəccər montajı",
    schemaType: "Service",
  },

  // 5) Digər
  "tent-perqola": {
    path: "/details/tent-perqola",
    title: "Tent-perqola – Açıq məkan üçün kölgə və qoruma sistemləri | AzGlass",
    description:
      "Tent və perqola sistemlərinin quraşdırılması. Kafe, restoran, bağ və həyətlər üçün funksional və estetik kölgə həlləri.",
    keywords:
      "tent, perqola, tent-perqola, kölgə sistemi, açıq məkan sistemi, perqola montajı",
    schemaType: "Service",
  },
  "izolasiya-sistemleri": {
    path: "/details/izolasiya-sistemleri",
    title: "İzolyasiya sistemləri – İstilik, səs və su izolyasiyası həlləri | AzGlass",
    description:
      "Binalar üçün istilik, səs və su izolyasiya sistemləri. Enerji qənaəti və komfort üçün peşəkar tətbiq və material seçimi.",
    keywords:
      "izolyasiya, istilik izolyasiyası, səs izolyasiyası, su izolyasiyası, enerji qənaəti",
    schemaType: "Service",
  },
  "agcaqanad-torlari": {
    path: "/details/agcaqanad-torlari",
    title: "Ağcaqanad torları – Pəncərə və qapılar üçün tor sistemləri | AzGlass",
    description:
      "Ağcaqanad torlarının hazırlanması və quraşdırılması. Rahat havalandırma, həşəratlardan qorunma və səliqəli montaj.",
    keywords:
      "ağcaqanad toru, mosquito net, pəncərə toru, qapı toru, tor sistemləri",
    schemaType: "Service",
  },
  cambalkon: {
    path: "/details/cambalkon",
    title: "Cambalkon – Balkon üçün şüşələmə və cambalkon sistemləri | AzGlass",
    description:
      "Cambalkon şüşələmə sistemlərinin quraşdırılması. Balkonunuz üçün qoruma, komfort və estetik görünüş verən həll.",
    keywords:
      "cambalkon, balkon şüşələmə, şüşələnmiş balkon, sliding glass, balkon sistemi",
    schemaType: "Service",
  },
  "qis-bagcalari": {
    path: "/details/qis-bagcalari",
    title: "Qış bağçaları – Şüşə konstruksiya ilə komfortlu məkanlar | AzGlass",
    description:
      "Qış bağçalarının layihələndirilməsi və quraşdırılması. İşıqlı, komfortlu və estetik şüşə konstruksiya həlləri.",
    keywords:
      "qış bağçası, şüşə konstruksiya, winter garden, şüşə veranda, bağ dizaynı",
    schemaType: "Service",
  },
};